import { render } from "./Freefields.vue?vue&type=template&id=496d50d0&scoped=true"
import script from "./Freefields.vue?vue&type=script&lang=js"
export * from "./Freefields.vue?vue&type=script&lang=js"

import "./Freefields.vue?vue&type=style&index=0&id=496d50d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496d50d0"]])

export default __exports__